/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { IndexSearchResultTypeKey } from './indexSearchResultTypeKey';
import { TagKey } from './tagKey';


export interface IndexSearchKey { 
    tagKey?: TagKey;
    indexSearchResultTypeKey?: IndexSearchResultTypeKey;
    /**
     * An optional boolean flag that specifies if business object definition associated with entire tag hierarchy is to be retrieved                
     */
    includeTagHierarchy?: boolean;
}
